import { useEffect, useState } from 'react'
import { gettingArrUniqueValues } from 'sections/options/sections/GlobalCashRegisters/utils'

export const useStartedList = (data, updatedData, key, t, tempLiteral = false) => {
	const [list, setList] = useState([])
	useEffect(() => {
		const arrItems = gettingArrUniqueValues(data, key)
		setList(arrItems.map(item => ({
			itemValue: item,
			name: item === 'null' ? 'keine fassung' : !tempLiteral ? item : t(`options_section.strings.${item}`)
		})))
	}, [data, updatedData])
	return list
}
